module.exports = __webpack_public_path__ + "img/chats.7f7cbf5f.png";